"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RECAPTCHA_RATE_LIMIT_ATTEMPT_TTL_SECONDS = exports.RECAPTCHA_RETRY_ALLOWED = exports.RECAPTCHA_HEADERS = void 0;
exports.RECAPTCHA_HEADERS = {
    TOKEN: "recaptcha-token",
    MISSING_SCRIPT: "recaptcha-missing-script",
    SCRIPT_START_TIME: "recaptcha-script-start-time",
    SCRIPT_END_TIME: "recaptcha-script-end-time",
    RETRY_COUNT: "recaptcha-retry-count",
    ATTEMPT_ID: "recaptcha-attempt-id",
    BROWSER_ERROR_EMAIL: "browser-error-email",
};
exports.RECAPTCHA_RETRY_ALLOWED = 2;
exports.RECAPTCHA_RATE_LIMIT_ATTEMPT_TTL_SECONDS = 120;
